import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/welcome'
import Bienvenido from '@/components/bienvenido'
import Huanyin from '@/components/huanyin'
import Info from '@/components/info'
import Acerca from '@/components/acerca'
import Guanyu from '@/components/guanyu'
import Contact from '@/components/contact'
import Contacto from '@/components/contacto'
import Lianxi from '@/components/lianxi'
import Services from '@/components/services'
import Servicios from '@/components/servicios'
import Fuwu from '@/components/fuwu'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/es',
      name: 'Bienvenido',
      component: Bienvenido
    },
    {
      path: '/cn',
      name: 'Huanyin',
      component: Huanyin
    },
    {
      path: '/info',
      name: 'Info',
      component: Info
    },
    {
      path: '/es/acerca',
      name: 'Acerca',
      component: Acerca
    },
    {
      path: '/cn/about',
      name: 'Guanyu',
      component: Guanyu
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/es/contacto',
      name: 'Contacto',
      component: Contacto
    },
    {
      path: '/cn/contact',
      name: 'Lianxi',
      component: Lianxi
    },
    {
      path: '/services',
      name: 'Services',
      component: Services
    },
    {
      path: '/es/servicios',
      name: 'Servicios',
      component: Servicios
    },
    {
      path: '/cn/services',
      name: 'Fuwu',
      component: Fuwu
    }
  ],
  // remove # in url
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js